import { t } from 'i18next'
import * as z from 'zod'

import type { UpdateFavoriteListTitleFormVO } from './type'

import type { InputOption } from '@/types'

const MAX_LENGTH = {
  name: 50,
  salesTypeCodes: 10,
}

export const schema = z.object({
  name: z
    .string()
    .min(1, { message: t('favorite.list.validation.required') })
    .max(MAX_LENGTH.name, {
      message: t('favorite.list.validation.max_length', {
        max: MAX_LENGTH.name,
      }),
    }),
  isShared: z.boolean(),
})

export const formLabels: Record<keyof UpdateFavoriteListTitleFormVO, string> = {
  name: t('favorite.list.name'),
  isShared: t('favorite.list.shared'),
}

export const DEFAULT_SELECTED_SALES_TYPE = '1'

export const formDefaultValues: Partial<UpdateFavoriteListTitleFormVO> = {
  name: undefined,
  isShared: false,
}

export const isSharedOptions: InputOption<boolean>[] = [
  {
    value: true,
    label: t('favorite.list.sharing.share'),
  },
  {
    value: false,
    label: t('favorite.list.sharing.not_share'),
  },
]
